export enum DuplicateOptionEnum {
  configOnly = 1,
  fullCopy = 2
}
